import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { isUser } from '../../Config/isUser';
import { isCompany } from '../../Config/isCompany';

const MainJobsCard = ({ post }) => {
  const [company, setCompany] = useState({});
  useEffect(() => {
    const fetchCompany = async () => {
      if (post.company_id) {
        try {
          const response = await axios.post(
            "https://kariyer.biyomed.net/api/companies/getOneDetailsCard",
            { company_id: post.company_id }, // `post` propsunu company_id olarak gönderiyoruz
            { withCredentials: true }
          );
          setCompany(response.data.company);
        } catch (error) {
          console.error("Error fetching company details:", error);
        }
      }

    };

    if (post) {
      fetchCompany(); // `post` değeri varsa istek yapılır
    }
  }, [post]);

  const formattedDate = new Date(post?.created_at).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleClick = (e, id, link, website) => {
    e.preventDefault();
    if (id) {
      window.location.href = isUser ? website ? website : `companyinfo/${id}` : "/login"
    }
    else {
      const correctedWebsite =
        website?.startsWith("http://") || website?.startsWith("https://")
          ? website
          : `https://${website}`;
      window.location.href = isUser ? website ? correctedWebsite : link : "/login";
    }

  }

  return (
    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ position: 'relative' }}>
      <div className="jp_job_post_main_wrapper_cont">
        <div className="jp_job_post_main_wrapper" style={{ filter: isUser || isCompany ? 'blur(0px)' : 'blur(3px)' }}> {/* Burada bulanıklık efekti uygulandı */}
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
              <div className="jp_job_post_side_img">
                <img
                  src={
                    company?.profile_image
                      ? company.profile_image
                      : post?.image && post.image.startsWith("https://")
                        ? post.image
                        : "https://pbs.twimg.com/profile_images/1305064450848960525/gsJVVM41_400x400.jpg"
                  }
                  alt="post_img"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "90px",
                    objectFit: "cover",
                  }}
                />

              </div>
              <div className="jp_job_post_right_cont">
                <h4>
                  {post.position_name.length > 30 ? post.position_name.slice(0, 30) + "..." : post.position_name}
                </h4>
                <p
                  onClick={(e) => handleClick(e, post.company_id, post.job_link, post.website)}
                  onMouseEnter={(e) => (e.target.style.color = "black")}
                  onMouseLeave={(e) => (e.target.style.color = "#23c0e9")}
                  style={{
                    fontSize: "14px",
                    marginTop: 10,
                    cursor: "pointer",
                    color: "#23c0e9", // Varsayılan renk
                    transition: "color 0.2s ease-in-out", // Yumuşak geçiş efekti
                  }}
                >
                  {post.company_name.length > 30 ? post.company_name.slice(0, 30) + "..." : post.company_name}
                </p>

                <ul>
                  <li>
                    <i className="fa fa-map-marker" />
                    &nbsp;
                    {post.city && post.city.split(',').length > 2 ? (
                      <>
                        {post.city.split(',').slice(0, 2).join(', ')}...
                        <span style={{ color: '#23c0e9' }}>+{post.city.split(',').length - 2} daha  </span>
                      </>
                    ) : (
                      post.city
                    )}
                  </li>
                  <li style={{ fontSize: '14px', marginTop: 3 }}>
                    <i className="fa fa-calendar" />
                    &nbsp; Yayımlama Tarihi: {formattedDate}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
              <div className="jp_job_post_right_btn_wrapper">
                <ul>
                  <li>
                  </li>
                  <li>
                    <a
                      href={(isUser ? (post.full_name ? `/apply-fast-post/${post.id}` : post.company_id ? `/apply-post/${post.id}` : post.job_link) : '/login')}
                      target={post.company_id ? "_self" : "_blank"}
                      rel={post.company_id ? "" : "noopener noreferrer"}
                    >
                      İncele
                    </a>
                  </li>
                  <li>
                    <a onClick={(e) => e.preventDefault()} style={{ backgroundColor: post?.job_type === "Is" ? '#4cc4ff' : '#f7b248' }} href="/">
                      {post?.job_type === "Is" ? "İş İlanı" : post?.job_type === "Staj" ? "Staj İlanı" : post?.job_type}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div style={{ filter: isUser || isCompany ? 'blur(0px)' : 'blur(3px)' }} className="jp_job_post_keyword_wrapper">
          <ul>
            {post.position_category ? <> <li>
              <i className="fa fa-tags" />
              Kategori :
            </li>
              <li>
                <a href="/">{post.position_category}</a>
              </li></> : <> <li>
                <i className="fa fa-tags" />
                Kategori :
              </li>
              <li>
                {post.position_category ? post.position_category.length > 35 ? post.position_category.slice(0, 35) + "..." : post.position_category : "Dış ilan"}
              </li></>}

          </ul>
        </div>
      </div>
    </div>
  )
}

export default MainJobsCard;
